var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._g({staticClass:"app-message",class:{
    warning: _vm.warning || _vm.type === _vm.MESSAGE_TYPE_WARNING,
    success: _vm.success || _vm.type === _vm.MESSAGE_TYPE_SUCCESS,
    info: _vm.info || _vm.type === _vm.MESSAGE_TYPE_INFO,
    danger: _vm.danger || _vm.type === _vm.MESSAGE_TYPE_DANGER,
  },style:({
    backgroundColor: _vm.backgroundColor,
    color: _vm.textColor,
  })},_vm.$listeners),[_vm._t("image",function(){return [(_vm.image)?_c('AppImage',{staticClass:"image",attrs:{"src":_vm.image}}):_vm._e()]}),_c('div',{staticClass:"content-wrapper"},[(_vm.title || _vm.$slots.title)?_c('h3',{staticClass:"title"},[_vm._t("title",function(){return [_vm._v(" "+_vm._s(_vm.title)+" ")]})],2):_vm._e(),(_vm.content || _vm.$slots.content || _vm.$slots.default)?_c('div',{staticClass:"content"},[(_vm.$slots.content)?_vm._t("content"):_vm._t("default",function(){return [_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})]})],2):_vm._e()])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }